import { post } from '@webapp-next/lib/request/webapp/http';

/**
 * @deprecated values are coming from the Mushodo GetRosters on page load
 */
export default async function getRosterCustomFieldValue({
  dpMetaOption = false,
  rosterId,
} = {}) {
  const options = {
    headers: {},
  };

  const body = JSON.stringify({
    search: { Id: { field: 'Id', type: 'eq', data: rosterId } },
    join: ['CustomFieldDataObject'],
  });

  if (dpMetaOption === false) {
    options.headers['dp-meta-option'] = 'none';
  }

  try {
    const { data } = await post('/api/v1/resource/Roster/QUERY', body, options);

    return {
      success: true,
      message: '',
      data: data || [],
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
